import { Column } from '@tanstack/react-table';
import { ArrowDown, ArrowUp, ChevronsUpDown } from 'lucide-react';
import { PropsWithChildren, useMemo } from 'react';
import { Icon } from '../Icon';

interface SortableHeaderProps<T> {
  column: Column<T>;
}

export function SortableHeader<T>({ column, children }: PropsWithChildren<SortableHeaderProps<T>>) {
  const sorted = column.getIsSorted();

  const SortIcon = useMemo(() => {
    if (sorted === 'asc') {
      return ArrowUp;
    } else if (sorted === 'desc') {
      return ArrowDown;
    }
    return ChevronsUpDown;
  }, [sorted]);

  const onClick = () => {
    if (sorted === 'asc') {
      column.clearSorting();
    } else if (sorted === 'desc') {
      column.toggleSorting(false);
    } else {
      column.toggleSorting(true);
    }
  };

  return (
    <div onClick={onClick} className="flex cursor-pointer select-none flex-row items-center">
      <span>{children}</span>
      <Icon type={SortIcon} className="ms-1" />
    </div>
  );
}
